angular
    .module('festzelt-os.contacts')
    .factory('createDocumentForOptions', [
            'DocumentCreateService',
            (DocumentCreateService) => new createDocumentForOptions(DocumentCreateService)
        ]
    );

class createDocumentForOptions {
    constructor(DocumentCreateService) {
        this.documentCreateService = DocumentCreateService;

        this.key = 'create-document-for-options';
        this.title = 'Create document';
        this.level = 'selected';
    }

    action(action, store, newValue) {
        const dataForCreate = {
            ...store.getters.selectedFilters
        };

        if (_.get(store.state, 'vm.objectModel.id', null)) {
            dataForCreate.object_id = _.get(store.state, 'vm.objectModel.id', null);
        }

        this.documentCreateService.startNewDocumentWizard('bo_options', store, dataForCreate);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/bo/options/workflows/options-list/create-document-for-options.js